import { LuArrowLeft, LuMail, LuShieldCheck, LuUserRound } from 'react-icons/lu';

function AdminProfilePage({ user, onBack }) {
  const name = user?.name?.trim() || 'Administrator';
  const email = user?.email?.trim() || 'Not available';
  const initials = name.split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();

  return (
    <section className="admin-profile-page" aria-labelledby="admin-profile-title">
      <header className="admin-profile-heading">
        <div>
          <span className="admin-eyebrow"><LuUserRound size={14} /> ACCOUNT CENTER</span>
          <h1 id="admin-profile-title">Your profile</h1>
          <p>Manage your identity and review your administrator access.</p>
        </div>
        <button className="admin-secondary-button" type="button" onClick={onBack}>
          <LuArrowLeft size={16} /> Back to dashboard
        </button>
      </header>

      <div className="admin-profile-grid">
        <article className="admin-profile-card admin-profile-identity">
          <div className="admin-profile-orbit admin-profile-orbit-one" aria-hidden="true" />
          <div className="admin-profile-orbit admin-profile-orbit-two" aria-hidden="true" />
          <div className="admin-profile-avatar" aria-hidden="true">{initials || 'AD'}</div>
          <div className="admin-profile-identity-copy">
            <span className="admin-profile-label">SIGNED-IN ADMINISTRATOR</span>
            <h2>{name}</h2>
            <p><LuMail size={16} />{email}</p>
          </div>
          <span className="admin-profile-status"><i /> Active account</span>
          <span className="admin-profile-hero-caption">AIRPORT OPERATIONS <b /> ADMIN CONSOLE</span>
        </article>

        <article className="admin-profile-card admin-profile-details-card">
          <div className="admin-profile-card-heading">
            <span className="admin-profile-card-icon"><LuUserRound size={19} /></span>
            <div><h2>Account details</h2><p>Your identity for this workspace</p></div>
          </div>
          <dl className="admin-profile-details">
            <div><dt>Full name</dt><dd>{name}</dd></div>
            <div><dt>Email address</dt><dd>{email}</dd></div>
            <div><dt>Account type</dt><dd><span className="admin-profile-role"><LuShieldCheck size={14} /> Administrator</span></dd></div>
          </dl>
        </article>

        <article className="admin-profile-card admin-profile-access">
          <span className="admin-profile-access-icon"><LuShieldCheck size={21} /></span>
          <div>
            <span className="admin-profile-label">SESSION SAFETY</span>
            <h2>Secure access</h2>
            <p>Your administrator session is active in this browser. Sign out when you finish on a shared device.</p>
          </div>
          <span className="admin-profile-session"><i /> Signed in</span>
        </article>
      </div>
    </section>
  );
}

export default AdminProfilePage;
